import { apiGet } from "../baseApi";

import { setOngoingIncidentData } from "service/mapper";
import { isValidValue } from "utils";

export const getList = async ({params={}, config = {}}) => {
  try {
    const response = await apiGet("_incident", params, null, config);
    if (!isValidValue(response.data?.incidents)) {
      response.data.incidents = [];
    }
    return {
      ...response,
      rowData: (Array.isArray(response.data.incidents) ? response.data.incidents : []).map((el) => setOngoingIncidentData(el)),
    };
  } catch (error) {
    return Promise.reject(error);
  }
};
